export const apiUrl = 'https://api.tacom.srv.br/';
export const praca = 'gvb';
export const apiLoginUrl = 'https://api.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'gvb-web@tacom.com.br';
export const password = 'M@PPDb8F63';

export const versaoSoftware = '4.4.18';
export const idioma = 'pt_BR'

export default {
}